import { useMutation } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../api/ApiRoutes";

const refundPendingTransaction = async ({
  user_id,
  transaction_id,
  refund_amount,
  notes,
  disclaimer_acknowledged,
}) => {
  if (
    !user_id ||
    !transaction_id ||
    !Number.isFinite(refund_amount) ||
    refund_amount <= 0 ||
    typeof notes !== "string" ||
    !notes.trim() ||
    disclaimer_acknowledged !== true
  ) {
    throw new TypeError("refundPendingTransaction: invalid arguments");
  }

  const token = JSON.parse(localStorage.getItem("token"));
  const privateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
  );

  const response = await privateAdminPanelInstance.post(
    API_ROUTES.REFUND_PENDING_TRANSACTION,
    {
      user_id,
      transaction_id,
      refund_amount,
      notes: notes.trim(),
      disclaimer_acknowledged: true,
    },
  );

  return response?.data ?? null;
};

export const useRefundPendingTransaction = () =>
  useMutation({
    mutationKey: ["REFUND_PENDING_TRANSACTION"],
    mutationFn: refundPendingTransaction,
  });
